import React, {useEffect, useState} from 'react';
import {MallsData} from "../../Malls/MallsServices";
import {getMallWithSubDomain} from "../../../Services";
import {useHistory} from "react-router";
import {getMallMerchant_api} from "../../../Services/apis";
import {useGetFetchQuery} from "../../../hooks/useGetFetchQuery";
import "./FooterMobile.scss";

function FooterMobile() {

    const mer = useGetFetchQuery(["merchant"]);
    const [data, set_data] = useState([])
    const [mall, set_mall] = useState(null)
    const history = useHistory()

    useEffect(() => {
        set_data(data)
    }, [])

    useEffect(() => {
        setTimeout(() => {
            getMallDe()
        }, 1000)
    }, [])


    const getMallDe = async () => {
        try {
            await getMallDetail()
            getMerchant()
        } catch (e) {
            console.log(e)
        }
    }


    const getMall = async (sub) => {
        try {
            return await getMallWithSubDomain(sub);
        } catch (e) {
            console.log(e)
        }
    }

    const getMallDetail = async () => {
        //detect sub or main link
        let full = window.location.hostname;
        let parts = full.split('.');

        let sub = "";
        let isAdmin = "";

        if (parts.length === 3 && parts[0] !== "www") {
            sub = parts[0]
        } else {
            sub = "app"
        }

        isAdmin = parts[0];

        if (isAdmin === "www" || isAdmin === "test")
            isAdmin = parts[1];

        if (isAdmin === "digimaall" || isAdmin === "test" || isAdmin === "stage" || isAdmin === "localhost" || isAdmin === "apluss" || isAdmin === "app") {
            let temp = isAdmin;
            isAdmin = "digimaall";
            if (temp === "app" && parts[1] !== "apluss") {
                isAdmin = "app"
                console.log("in")
            }

        }


        let token = localStorage.getItem("token");

        if (isAdmin !== "digimaall") {
            let malli = await getMall(sub)
            localStorage.setItem('mallId',malli.data.uid);
            localStorage.setItem('mallLogo',malli.data.header_image);
            localStorage.setItem('mall',malli.data.logo);
            localStorage.setItem('mallName',malli.data.name);
            localStorage.setItem('mall',JSON.stringify(malli.data));
            localStorage.setItem('theme',JSON.stringify({
                primary:malli.data.primary_color.color,
                secondary:malli.data.secondary_color.color,
                tertiary:malli.data.tertiary_color.color
            }));
            set_mall(malli.data)

        }
    }

    const [merchant,set_merchant] = useState(null)
    const getMerchant = async () => {
        try {
            const res = await getMallMerchant_api()
            console.log("Merchant in Footer :",res.data)
            set_merchant(res.data)
        } catch (e) {
            console.log(e)
        }
    }

    const gotTo = (page) => {
        history.push("/" + page)
    }

    return (
        <div className="footer-mobile">


            <div className="footer_label">
                <span>{merchant?.merchant_extra_info?.name}</span>
            </div>

            <div className="footer_merchant-about">
                {merchant?.merchant_extra_info?
                    <p>
                        {merchant?.merchant_extra_info.about_footer}
                    </p>:
                    <p>---</p>}
            </div>

            <div className="footer_label">
                <span>تلفن تماس : </span>
            </div>

            <div className="footer-phones">
                {merchant?.merchant_extra_info?
                    <div className="footer-phone">
                        <span className="phone">{merchant.merchant_extra_info.phone1}</span>
                        <span className="phone">{merchant.merchant_extra_info.phone2}</span>
                    </div>
                    :
                    <span>---</span>
                }
            </div>


            <div className="footer_label">
                <span>آدرس :</span>
            </div>


            <div className="footer-address">
                <p>
                    {mall?.description ? mall.description : "---"}
                </p>
            </div>



            <div className="footer-row">

                <div className="home-new-responsive-footer-col-namads">
                    {mall?.enamad_info ? <div dangerouslySetInnerHTML={{__html: `${mall?.enamad_info}`}}/>
                        : null}
                </div>

                <div className="footer-links">
                    <ul>
                        <li onClick={e => gotTo("license")}>درباره ما</li>
                        <li onClick={e => gotTo("terms-guid")}>قوانین و مقررات</li>
                        <li onClick={e => gotTo("shop-guid")}>راهنمای خرید از داروخانه آنلاین</li>
                        <li onClick={e => gotTo("privacy-policy")}>حفظ و رعایت حریم شخصی مشتریان</li>
                    </ul>
                </div>

            </div>










        </div>

    )
}

export default FooterMobile;

